function navegacaoDeOndeImportar() {
  return window.location.href.includes('/de-onde-importar');
}


function constroiBreadcrumbDeOndeExportar() {
  if(navegacaoDeOndeImportar()) {
    construirBreadcrumb(['inicio', 'internacionalizacao']);
  }
}
